import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { itiMessageService, store } from '@/iti-core-vue';
import { CategorySecondLevel } from '@/shared/dtos/category-second-level';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'CategorySecondLevelModule',
    store,
    dynamic: true,
})

class CategorySecondLevelModule extends VuexModule implements BaseModule {
    public categories: CategorySecondLevel[] = [];

    @Mutation
    public resetState(): void {
        this.categories = [];
    }



    @Action
    public async getCategoriesSecondLevel() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.categorySecondLevel);
        this.context.commit('updateCategoriesSecondLevel', res);
    }

    @Mutation
    public updateCategoriesSecondLevel(items: CategorySecondLevel[]) {
        this.categories = items/*.map(x => new CategorySecondLevel(x))*/;
    }

    @Action
    public async insertarCategorySecondLevel(item: CategorySecondLevel) {
        if (!itiTokenService.hasToken()) { return; }
        var res = await itiHttpService.post(API.categorySecondLevel, item, false);
        this.context.dispatch('getCategoriesSecondLevel');
    }

    @Action
    public async modificarCategorySecondLevel(item: CategorySecondLevel) {
        if (!itiTokenService.hasToken()) { return; }
        //const apiUpdateCategory = ItiString.Format(API.categorySecondLevelDetail, item.id);
        try {
            const res = await itiHttpService.put(API.categorySecondLevel, item, false);
        } catch {
            // ...
        }
        this.context.dispatch('getCategoriesSecondLevel');
    }

    @Action
    public async eliminarCategorySecondLevel(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteCategory = ItiString.Format(API.categorySecondLevelDetail, id);
        const res = await itiHttpService.delete(apiDeleteCategory, id, false);
        this.context.dispatch('getCategoriesSecondLevel');
    }
}

export default getModule(CategorySecondLevelModule);